import { BoolString } from './withdrawal';

// H5 入口的位置
export enum H5Entrance {
  Main = 'Main', // 主入口
  Repay = 'Repay', // 立即还卡入口
  Navigate = 'Navigate', // loading入口
  eDDA = 'eDDA', // edda管理入口
  Repayment = 'Repayment', // 借款记录入口
  BillMgmt = 'BillMgmt', // 账单管理入口
  CashLoanMain = 'CashLoanMain', // CashLoan的主入口
  CashLoanNavigate = 'CashLoanNavigate', // CashLoan的loading页
  KKCAppeal = 'KKCAppeal', // kkc原生提额入口
  KKCClearCard = 'KKCClearCard', // kkc清卡入口
  KKCCashout = 'KKCCashout', // kkc提现入口
  CLClearCard = 'CLClearCard', // cl清卡入口
  CLCashout = 'CLCashout', // cl提现入口
  DirectSale = 'DirectSale', // 直售提现入口
}

export const KKCEntranceList = [H5Entrance.Repay, H5Entrance.KKCClearCard, H5Entrance.KKCCashout];

export const CLEnteranceList = [
  H5Entrance.CashLoanNavigate,
  H5Entrance.CLClearCard,
  H5Entrance.CLCashout,
];

// H5 流程状态
export enum H5ProcessState {
  Credit,
  Withdrawal,
}

export type UserInfoType = {
  userId: string;
  userName: string;
  mobilePhone: string;
  encryptPhone: string;
  englishName?: string;
  englishNameShow?: string; // 用于展示的带掩码的英文名字
  isEkyc?: BoolString; // 是否执行了eKYC
  isPwd?: BoolString; // 是否设置密码
  verCode?: string; // 验证码
  vip5Flag?: BoolString; // 是否vip5客户
};

export type PartialUserInfo = Partial<UserInfoType>;

// ekyc成功之后，将执行什么操作
export enum EkycNextOperation {
  CheckCreditState = 1,
  CreateCreditAndCheckState = 2,
  CheckBillMgmtState = 3,
  CheckClCreditState = 4,
  CheckCmcCreditState = 5,
  CashLoanCashOut = 6, // 现金贷提现
  CheckBillMgmtReportState = 7, // 账单管理报表状态
  DsFullEkyc = 8, // DirectSale全Ekyc
  TipTopCLEkyc = 9, // TipTop CL全Ekyc
  WhatsappFlow_Liveness = 10, // WhatsappFlow 活体校验
}

// ekyc是从什么位置来的  前端自定的
export enum EkycSource {
  Credit = '01', // KKC授信
  BillMgmt = '02',
  ClCredit = '03',
  CreditIntro = '04', // KKC授信产品页
  ClCreditIntro = '05', // CL授信产品页
  CashLoanLoading = '06', // CL 放款loading页
  BillMgmtReports = '07', // 账单管理报表页
  DsFullEkyc = '08', // DirectSale全Ekyc
  TipTopCLEkyc = '09', // TipTop CL全Ekyc
  WhatsappFlow = '10', // WhatsappFlow
}

export type EkycType = '01' | '02' | '03' | '07' | '08' | undefined; // 传给后端的ekyc类型

export enum RepaymentType {
  PERSONAL = '01', // 出粮日
  PLATFORM = '02', // 借据日
}

export type SalaryCardType = {
  bankId: string;
  bankName: string;
  bankNameAbbr: string;
  bankNum: string;
  bankNumShow: string;
  paymentTime?: string;
  remark: string;
  paymentType?: RepaymentType;
};
